<template>
  <section class="business-overlay-layer" aria-label="业务大屏浮层">
    <header class="overlay-top-center">
      <h1 class="business-screen-title">古贤水利枢纽水网</h1>
    </header>

    <div class="overlay-top-left"><slot name="top-left" /></div>
    <div class="overlay-top-right"><slot name="top-right" /></div>

    <div class="overlay-bottom-left-stack" data-testid="bottom-left-stack">
      <div class="overlay-item"><slot name="bottom-left-top" /></div>
      <div class="overlay-item"><slot name="bottom-left-bottom" /></div>
    </div>

    <div class="overlay-bottom-center"><slot name="bottom-center" /></div>
    <div class="overlay-bottom-right-stack"><slot name="bottom-right" /></div>
  </section>
</template>

<script>
export default {
  name: 'BusinessOverlayLayer',
}
</script>

<style scoped>
.business-overlay-layer {
  --overlay-edge-gap: clamp(10px, 1.1vw, 20px);
  --overlay-item-gap: clamp(12px, 0.85vw, 16px);
  --overlay-title-z: 1;
  --overlay-panel-z: 2;
  --overlay-modal-z: 3;
  --overlay-bottom-safe-area: max(var(--overlay-edge-gap), env(safe-area-inset-bottom));

  position: fixed;
  inset: 0;
  z-index: 10010;
  pointer-events: none;
}

.overlay-top-center {
  position: absolute;
  top: var(--overlay-edge-gap);
  left: 50%;
  z-index: var(--overlay-title-z);
  transform: translateX(-50%);
  pointer-events: none;
}

.business-screen-title {
  margin: 0;
  padding: 7px clamp(22px, 2.2vw, 42px) 9px;
  border: 1px solid rgba(103, 232, 249, 0.22);
  border-radius: 10px;
  color: #f4fdff;
  background: linear-gradient(90deg, rgba(5, 18, 34, 0.14), rgba(5, 35, 48, 0.82), rgba(5, 18, 34, 0.14));
  box-shadow: 0 8px 24px rgba(0, 10, 24, 0.2);
  font-family: HYk2gj, "Microsoft YaHei", sans-serif;
  font-size: clamp(22px, 2vw, 38px);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: clamp(2px, 0.32vw, 6px);
  text-align: center;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.72), 0 0 16px rgba(56, 189, 248, 0.28);
  white-space: nowrap;
  pointer-events: none;
}

.overlay-top-left,
.overlay-top-right,
.overlay-bottom-center,
.overlay-bottom-right-stack {
  position: absolute;
  z-index: var(--overlay-panel-z);
}

.overlay-top-left {
  top: var(--overlay-edge-gap);
  left: var(--overlay-edge-gap);
}

.overlay-top-right {
  top: var(--overlay-edge-gap);
  right: var(--overlay-edge-gap);
}

.overlay-bottom-left-stack {
  position: absolute;
  left: var(--overlay-edge-gap);
  bottom: var(--overlay-bottom-safe-area);
  z-index: var(--overlay-panel-z);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--overlay-item-gap);
  width: min(360px, calc(100vw - var(--overlay-edge-gap) - var(--overlay-edge-gap)));
  max-height: calc(100vh - 96px - var(--overlay-bottom-safe-area));
  max-height: calc(100dvh - 96px - var(--overlay-bottom-safe-area));
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  pointer-events: auto;
}

.overlay-item {
  flex: 0 0 auto;
  width: 100%;
  max-width: 100%;
  pointer-events: auto;
}

.overlay-bottom-center {
  bottom: var(--overlay-bottom-safe-area);
  left: 50%;
  transform: translateX(-50%);
}

.overlay-bottom-right-stack {
  right: var(--overlay-edge-gap);
  bottom: var(--overlay-bottom-safe-area);
}

.overlay-top-left,
.overlay-top-right,
.overlay-bottom-center,
.overlay-bottom-right-stack,
.overlay-top-left > *,
.overlay-top-right > *,
.overlay-bottom-center > *,
.overlay-bottom-right-stack > * {
  pointer-events: auto;
}

@media (max-width: 1400px) {
  .business-screen-title {
    padding: 6px 20px 7px;
    font-size: clamp(22px, 2.4vw, 30px);
  }

  .overlay-bottom-left-stack {
    max-height: calc(100vh - 112px - var(--overlay-bottom-safe-area));
    max-height: calc(100dvh - 112px - var(--overlay-bottom-safe-area));
  }
}

@media (max-width: 760px) {
  .business-overlay-layer {
    --overlay-edge-gap: 10px;
    --overlay-item-gap: 12px;
  }

  .business-screen-title {
    max-width: calc(100vw - 28px);
    overflow: hidden;
    padding-inline: 14px;
    font-size: clamp(20px, 5.4vw, 26px);
    letter-spacing: 2px;
    text-overflow: ellipsis;
  }

  .overlay-bottom-left-stack {
    width: min(340px, calc(100vw - 20px));
  }
}
</style>
